<template>
  <div>
    <tab v-model="actived"></tab>
    <div v-for="(item, index) of orderlist" :key="index" class="list-wrap">
      <div class="pro-top">
        <!-- <p class="pro-tiem"> <span>{{item.add_time}}</span> </p> -->
      </div>
      <div class="pro-list">
        <ul @click="gotoOrderInfo(item.order_sn)">
          <li v-for="(item2, index2) of item.order_goods" :key="index2">
            <div class="pro-img">
              <img :src="item2.goods_pic" v-if="item2.goods_pic" />
            </div>
            <div class="pro-content">
              <div class="pro-name">{{ item2.goods_name }}</div>
              <div class="pro-size"></div>
              <div class="pro-wrap">
                <p>{{ $setInfoDecimal(item2.goods_price) }} ¥</p>
                <p>X{{ item2.goods_num }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="pay">
        <div class="goodsAmont">
          <div>共 <span>{{ item.order_goods.length }}</span> 件商品</div>
          <div>小计: <span>{{ $setInfoDecimal(item.payment.order_price) }} ¥</span></div>
        </div>

        <div class="total">
          <div class="goods-info">

            <!-- <div> <span>{{item.add_time}} </span></div> -->
          </div>
          <button @click="gotoOrderInfo(item.order_sn)" v-if="item.order_status === 1">去支付</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getorderlist } from "@/api/order"
import tab from './components/tab.vue'
import scroll from '@/mixins/scroll'

export default {
  components: {
    tab
  },
  data () {
    return {
      orderlist: [],
      actived: 0
    }
  },
  mixins: [scroll],
  methods: {
    showS (i) {
      this.orderlist[i].show = !this.orderlist[i].show
    },
    async getList () {
      const result = await getorderlist({
        order_status: this.actived || this.$route.query.typeId,
        page: this.page,
        size: 5,
      })
      if (result.data.data.orderList.data.length !== 0) {
        result.data.data.orderList.data.map(item => {
          item.show = false
        })
        this.orderlist = this.orderlist.concat(result.data.data.orderList.data)
      } else {
        this.page = null
      }
    },
    gotoOrderInfo (order_sn) {
      this.$router.replace({
        name: 'orderInfo',
        query: { odId: order_sn }
      })
    },
  },
  watch: {
    actived () {
      this.orderlist = []
      this.page = 1
      this.getList()
    }
  },
  filters: {
    orderstatus (value) {
      switch (value) {
        case 4:
          return '未发货'
        case 5:
          return '已发货'
      }
    },
    show (value) {
      return value ? '收起' : '查看订单详情'
    }
  }
}
</script>
<style lang="scss" scoped>
.list-wrap {
  width: 6.78rem;
  padding: 0.2rem;
  background: white;
  margin: auto;
  margin-top: 0.5rem;
  border-radius: 10px;
  .pro-list {
    ul {
      li {
        font-size: 0.28rem;
        display: flex;
        padding-bottom: 0.1rem;
        margin-bottom: 0.1rem;
        border-bottom: 1px solid #efefef;
        .pro-img {
          width: 1.71rem;
          height: 1.71rem;
          img {
            height: 100%;
          }
        }
        .pro-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 0.3rem;
          width: 5rem;
          .pro-name {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .pro-wrap {
            display: flex;
            justify-content: space-between;
            font-weight: 700;
          }
        }
      }
    }
  }
}
.goodsAmont {
  display: flex;
  justify-content: space-between;
}
.pro-top {
  font-size: 0.25rem;
}
.pro-tiem {
  text-align: right;
}
.pay {
  font-size: 0.28rem;
  div {
    margin: 0.1rem 0;
  }
  span {
    font-weight: 600;
  }
  .total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      width: 1.62rem;
      padding: 0.1rem 0;
      color: #fff;
      background: #ff6161;
      border: none;
      border-radius: 5px;
    }
  }
}
</style>
